import imomoLoginOptions from './login.component';
import imomoLoginCardComponent from './login-card.component';


export default angular.module('imomo.login', [])
    .component('imomoLogin', imomoLoginOptions)
    .component('imomoLoginCard', imomoLoginCardComponent)
    .name;



/** WEBPACK FOOTER **
 ** ./app/login/login.module.ts
 **/